<template>
  <div class="technologyDivParent">
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="divImg">
      <img 
      v-lazy="{
        src:bgUrl,
        loading: require('./../../../../../assets/wheelplanting.jpg')
      }"
       />
      <ul>
        <li v-for="item in details" :key="item">
          <em></em><span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    bgUrl: {
      type: String,
      default: "",
    },
    details: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/technologyWidge.scss";
</style>
